import { FETCH_SCENARIO_INFORMATION } from '../../constants/bulkScenarioGroup/bulkScenarioInfoConstants';

const INITIAL_STATE = {
    scenarioInfo: undefined
}

export const scenarioInfoReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case FETCH_SCENARIO_INFORMATION:
            return {
                scenarioInfo: action.payload
            }

        default:
            return state;
    }
}